import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LtiService } from '../../lti/core/lti.service';
import { DialogService } from '../../rl-common/dialogs/core/dialog.service';
import { CustomButton } from '../../rl-common/dialogs/shared/custom-button';
import { CustomDialogWindow } from '../../rl-common/dialogs/shared/custom-dialog-window';
import { UtilsService } from '../../rl-common/shared/core/utils.service';
import { AssignmentService } from '../core/assignment.service';
import { SubmissionService } from '../core/submission.service';
import { Assignment } from '../shared/assignment';
import { StudentSubmission } from '../shared/student-submission';
import { Submission } from '../shared/submission';
import { SubmissionViewComponent } from '../submission-view/submission-view.component';

@Component({
  selector: 'rl-assignment-grading',
  templateUrl: './assignment-grading.component.html',
  styleUrls: ['./assignment-grading.component.scss', './assignment-grading.component-rtl.css']
})
export class AssignmentGradingComponent implements OnInit, AfterViewInit {

  @ViewChild(SubmissionViewComponent) submissionForm : SubmissionViewComponent;

  asgmt : Assignment;
  allSubs : StudentSubmission[] = [];
  currIndex : number = 0;
  saveChangesDialog : CustomDialogWindow = new CustomDialogWindow();

  constructor(private route: ActivatedRoute, private assignmentService : AssignmentService, private submissionService : SubmissionService, private dialog : DialogService,
    private utils : UtilsService, private ltiService : LtiService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.assignmentService.get(params.get('aid')).subscribe(a => this.asgmt = a);
      let subId = params.get('sid');
      if(subId) {
        this.submissionService.get(params.get('sid')).subscribe(sub => {
          this.ltiService.getUser(sub.lmsUserId).subscribe(user => {
            let ss = new StudentSubmission(user);
            ss.submission = sub;
            this.allSubs.push(ss);
          })
        });
      } else {
        this.assignmentService.getNotGradedStudentSubmissions(params.get('aid')).subscribe(subs => {
          subs.forEach(s => this.allSubs.push(new StudentSubmission(s)));
        });
      }
    });
  }

  ngAfterViewInit(){
    let saveBtn = new CustomButton("btn.save", undefined, 'left');
    saveBtn.focus = true;
    saveBtn.main = true;
    this.saveChangesDialog = new CustomDialogWindow('grading.popup.unsavechanges.title', 'grading.popup.unsavechanges.msg', [saveBtn, new CustomButton("btn.continue", undefined, 'right')]);
  }

  onSaveSubmission(res : {oldSub : Submission, newSub : Submission}){
    this.updateStatistics(res.oldSub.grade, res.newSub.grade);
    this.allSubs[this.currIndex].submission = res.newSub;
  }

  updateStatistics(oldGrade : number, newGrade : number){
    let callStats = false;
    if(oldGrade == newGrade) return;
    if(oldGrade == undefined && newGrade != undefined) {
      if(this.asgmt.statistics.low == undefined || this.asgmt.statistics.low > newGrade) this.asgmt.statistics.low = newGrade;
      if(this.asgmt.statistics.high == undefined || this.asgmt.statistics.high < newGrade) this.asgmt.statistics.high = newGrade;
      this.asgmt.statistics.graded++;
    }
    if(oldGrade != undefined && newGrade == undefined) {
      this.asgmt.statistics.graded--;
      if(this.asgmt.statistics.graded == 0) this.asgmt.statistics.low = this.asgmt.statistics.high = undefined;
      else callStats = true;
    }
    if(oldGrade != undefined && newGrade != undefined) {
      if(this.asgmt.statistics.graded == 1) this.asgmt.statistics.low = this.asgmt.statistics.high = newGrade;
      else if(oldGrade != this.asgmt.statistics.high && oldGrade != this.asgmt.statistics.low) {
        if(this.asgmt.statistics.low > newGrade) this.asgmt.statistics.low = newGrade;
        if(this.asgmt.statistics.high < newGrade) this.asgmt.statistics.high = newGrade;
      }else callStats = true;
    }
    callStats ? this.assignmentService.getStatistics(this.asgmt.id).subscribe((stats : any)=> this.asgmt.statistics = stats)
                : this.asgmt.statistics.avg = this.utils.recalcAverage(this.asgmt.statistics.avg,this.asgmt.statistics.graded, oldGrade, newGrade);
  };

  next = () => this.hasUnSaveChanges() ? this.askForSaveChanges('next') : this.currIndex++;

  prev = () => this.hasUnSaveChanges() ? this.askForSaveChanges('prev') : this.currIndex--;

  hasUnSaveChanges = () => this.submissionForm?.hasChanges();

  askForSaveChanges(moveTo : 'next' | 'prev'){
    let continueFn = () => {
      //this.submissionForm.reset();
      this.currIndex += (moveTo == 'next' ? 1 : -1);
    };

    let saveFn = () => {
      this.submissionForm.save(moveTo);
      this.currIndex += (moveTo == 'next' ? 1 : -1);
    };

    this.saveChangesDialog.buttons[0].action = saveFn;
    this.saveChangesDialog.buttons[1].action = continueFn;
    
    this.dialog.openDialog(this.saveChangesDialog);
  }

}
